export default "<div class=\"alert\" role=\"alert\">\n    <span>{{ message }}</span>\n  </div>"